import { createFileRoute } from "@tanstack/react-router";
import { PublicRoadmapPage } from "@/components/portal/roadmap-page";

export const Route = createFileRoute("/p/$slug/")({
  component: PublicRoadmap,
});

/**
 * A project's public roadmap. Open to anyone: nothing here asks who is
 * reading. It is the index of `/p/<slug>` and not a layout, so the public
 * pages beside it are routes of their own.
 */
function PublicRoadmap() {
  const { slug } = Route.useParams();
  // Keyed by the address, so one project's votes in flight never land on another's page.
  return <PublicRoadmapPage key={slug} slug={slug} />;
}
